export default __webpack_public_path__ + "static/media/save.b86e78b3.svg";